import React, { Component } from 'react';
import { Col, Card, } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';

class NuclearTemplates extends Component {

    constructor() {
        super();
        this.state = {
            history: '',
            description: '',
            tecnic: '',
            opinion: '',
            observation: '',
            note: '',
        }
    }

    render() {

        return (
            <div className="form" style={{ display: "flex", flexDirection: "column" }}>
                <div className="card__title">
                    <h5 className="bold-text">Examen Físico</h5>
                </div>

                <div className="form__form-group">
                    <span className="form__form-group-label">Antecedentes</span>
                    <div className="form__form-group-field">
                        <textarea
                            name="textarea-history"
                            defaultValue={this.props.data.antecedentes}
                            onChange={(e) => { this.props.handlerNuclear('antecedentes', e.target.value) }}
                        >
                        </textarea>
                    </div>
                </div>
                <div className="form__form-group">
                    <span className="form__form-group-label">Técnica</span>
                    <div className="form__form-group-field">
                        <textarea
                            name="textarea-tecnic"
                            defaultValue={this.props.data.tecnica}
                            onChange={(e) => { this.props.handlerNuclear('tecnica', e.target.value) }}
                        >
                        </textarea>
                    </div>
                </div>
                <div className="form__form-group">
                    <span className="form__form-group-label">Descripción</span>
                    <div className="form__form-group-field">
                        <textarea
                            name="textarea-descrip"
                            defaultValue={this.props.data.descripcion}
                            onChange={(e) => { this.props.handlerNuclear('descripcion', e.target.value) }}
                        >
                        </textarea>
                    </div>
                </div>
                <div className="form__form-group">
                    <span className="form__form-group-label">Opinión</span>
                    <div className="form__form-group-field">
                        <textarea
                            name="textarea-opinion"
                            defaultValue={this.props.data.opinion}
                            onChange={(e) => { this.props.handlerNuclear('opinion', e.target.value) }}
                        >
                        </textarea>
                    </div>
                </div>
                <div className="form__form-group">
                    <span className="form__form-group-label">Observación</span>
                    <div className="form__form-group-field">
                        <textarea
                            name="textarea-observ"
                            defaultValue={this.props.data.observacion}
                            onChange={(e) => { this.props.handlerNuclear('observacion', e.target.value) }}
                        >
                        </textarea>
                    </div>
                </div>
                <div className="form__form-group">
                    <span className="form__form-group-label">Nota</span>
                    <div className="form__form-group-field">
                        <textarea
                            name="textarea-note"
                            defaultValue={this.props.data.nota}
                            onChange={(e) => { this.props.handlerNuclear('nota', e.target.value) }}
                        >
                        </textarea>
                    </div>
                </div>
            </div>
        );
    }
}

export default reduxForm({
    form: `nuclear-temple-form`, // a unique identifier for this form
})(withTranslation('common')(NuclearTemplates));